import { PageResponse } from '@models/page-response';
import { MainComponent } from '../main/main.component';
import { TranslateService } from '@ngx-translate/core';
import { AppConstant } from '@constants/app.constant';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { Subject } from 'rxjs';
import { Component } from '@angular/core';
import { switchMap, debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { ModulePathConstant } from '@app/constants/modulePath.constant';
import { ProductService } from '@app/services/product.service';
import { OnepageProduct, OnepageProductFormSearchingCriteria, OnepageProductStatus } from '@app/models/onepage-product';

@Component({
    templateUrl: './product-list.component.html',
    styleUrls: ['./product-list.component.scss']
})
export class ProductListComponent {

    private searchTermStream = new Subject<string>();

    loading: boolean = false;

    globalCriteria: string = '';
    searchingCriteria: OnepageProductFormSearchingCriteria = new OnepageProductFormSearchingCriteria();


    statusOptions: OnepageProductStatus[] = ['ENABLED', 'DISABLED'];
    page: number = 1;
    size: number = 10;
    totalItems: number = 0;
    sortField: string;
    sortDirection: 'asc' | 'desc';

    pagingInfo: {
        start: number;
        end: number;
        total: number;
    }

    records: OnepageProduct[];

    constructor(private router: Router,
        private route: ActivatedRoute,
        public appConstant: AppConstant,
        private onepageProductService: ProductService,
        private translate: TranslateService,
        private mainComponent: MainComponent) {
    }

    ngOnInit(): void {

        this.loading = true;
        this.pagingInfo = {
            start: 0,
            end: 0,
            total: 0
        }

        this.route.params
            .pipe(
                switchMap((params: Params) => {
                    this.globalCriteria = params['global'] || '';
                    this.page = Number(params['page']) || 1;
                    this.sortField = params['sortField'] || 'productCode';
                    this.sortDirection = params['sortDirection'] || 'asc';

                    if (params['searchingCriteria'] != null) {
                        this.searchingCriteria = JSON.parse(params['searchingCriteria']);
                    } else {
                        this.searchingCriteria = new OnepageProductFormSearchingCriteria();
                    }

                    return this.onepageProductService.globalSearch(this.globalCriteria, this.searchingCriteria, this.page - 1, this.size, this.sortField, this.sortDirection);
                })
            )
            .subscribe((res: PageResponse<OnepageProduct>) => {
                this.loading = false;
                this.page = res.number + 1;
                this.totalItems = res.totalElements;
                
                this.records = res.content;
                this.pagingInfo.start = (this.page - 1) * this.size + 1;
                this.pagingInfo.end = this.page * this.size;
                this.pagingInfo.total = this.totalItems;
                if (this.pagingInfo.end > this.pagingInfo.total) {
                    this.pagingInfo.end = this.pagingInfo.total;
                }
            });

        this.searchTermStream
            .pipe(debounceTime(500), distinctUntilChanged())
            .subscribe((term: string) => this.doSearch(this.globalCriteria, this.page, this.sortField, this.sortDirection));

    }

    sort(field: string): void {
        this.sortField = field;

        if (this.sortField === field) {
            this.sortDirection === 'asc' ? this.sortDirection = 'desc' : this.sortDirection = 'asc';
        } else {
            this.sortField = field;
            this.sortDirection === 'asc';
        }

        this.doSearch(this.globalCriteria, this.page, field, this.sortDirection);
    }

    ngOnDestroy(): void {
    }

    pageChange(changedPage: number): void {
        if (this.page != changedPage) {
            this.doSearch(this.globalCriteria, changedPage, this.sortField, this.sortDirection);
        }
    };

    search(term: string) {
        this.searchTermStream.next(term);
    }

    submitSearch(): void {
        this.doSearch(this.globalCriteria, this.page, this.sortField, this.sortDirection);
    }

    private doSearch(criteria: string, page: number, sortField: string, sortDirection: string) {
        this.records = [];
        this.loading = true;
        this.router.navigate([ModulePathConstant.PRODUCT_PATH, {
            global: criteria,
            page: page,
            sortField: sortField,
            sortDirection: sortDirection,
            searchingCriteria: JSON.stringify(this.searchingCriteria)
        }]);
    }
}
